import * as types from './mutation-types'
import ClientDB from '@/rahmen/clientDB'
import conf from '@/rahmen/conf'

export const loadDatas = ({ commit }) => {
  console.log('usersBeforeLogin:loadDatas')
  return new Promise((resolve, reject) => {
    const db = new ClientDB(conf.beforeLoginInfoStoreName)
    console.log('usersBeforeLogin:db open', conf.beforeLoginInfoStoreName)
    db.get(0).then((data) => {
      console.log('usersBeforeLogin:get')
      console.log(data)
      if (data === undefined || data.value === undefined) {
        console.log('no data registed')
        reject(data)
        return
      }
      commit(types.SAVE_BEFORE_LOGIN_INFO, data.value)
      resolve()
    }).catch((e) => {
      console.log('usersBeforeLogin:get error', e)
      reject(e)
    })
  })
}
export const saveDatas = ({ commit }, beforeLoginInfo) => {
  _saveDataToDB(beforeLoginInfo)
}

const _saveDataToDB = (beforeLoginInfo) => {
  console.log('usersBeforeLogin:save start', beforeLoginInfo)
  const db = new ClientDB(conf.beforeLoginInfoStoreName)
  db.register(0, beforeLoginInfo)
    .catch(e => {
      console.error(e)
    })
}
